(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Header ---------- */
  document.addEventListener('click', function (e) {
    var menuBtn = e.target.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = document.getElementById('MobileNav');
      var open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
    }
    var searchBtn = e.target.closest('[data-search-toggle]');
    if (searchBtn) {
      var bar = document.getElementById('HeaderSearch');
      var sOpen = bar.classList.toggle('is-open');
      searchBtn.setAttribute('aria-expanded', sOpen);
      if (sOpen) bar.querySelector('input[type="search"]').focus();
    }
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var useDrawer = drawer && window.theme && window.theme.cartType === 'drawer';
  var isCartPage = !!document.querySelector('[data-cart-page]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    var opener = e.target.closest('[data-cart-open]');
    if (opener && useDrawer && !isCartPage) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function renderDrawer(sections) {
    if (!sections || !sections['cart-drawer'] || !drawer) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-cart-contents]');
    var current = drawer.querySelector('[data-cart-contents]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    }
  }

  /* ---------- Add to cart (all product forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (!useDrawer) return; // normal submit → cart page
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = res.json.description || res.json.message || 'Something went wrong. Please try again.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { alert(msg); }
          return;
        }
        renderDrawer(res.json.sections);
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Change cart line quantities ---------- */
  function changeLine(line, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  function handleLine(el, qty) {
    var item = el.closest('[data-line]');
    if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    item.style.opacity = '.5';
    changeLine(line, Math.max(0, qty)).then(function (json) {
      if (el.closest('[data-cart-page]')) { window.location.reload(); return; }
      renderDrawer(json.sections);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (b) { e.preventDefault(); handleLine(b, parseInt(b.getAttribute('data-line-change'), 10)); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-line-input]')) handleLine(e.target, parseInt(e.target.value, 10) || 0);
  });

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = section.querySelector('form[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var planInput = form.querySelector('[data-selling-plan]');
    var addBtn = form.querySelector('[data-add-button]');

    function currentVariant() {
      var id = parseInt(idInput.value, 10);
      return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
    }
    function selectedPlanId() {
      var r = form.querySelector('[data-plan-radio]:checked');
      return r && r.value ? parseInt(r.value, 10) : null;
    }
    function priceFor(variant, planId) {
      if (!planId) return variant.price;
      var alloc = (variant.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === planId; });
      return alloc ? alloc.price : variant.price;
    }

    function refresh() {
      var v = currentVariant();
      var planId = selectedPlanId();

      if (planInput) {
        if (planId) { planInput.value = planId; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      }

      form.querySelectorAll('[data-plan-price]').forEach(function (el) {
        var pid = el.getAttribute('data-plan-price');
        el.textContent = formatMoney(priceFor(v, pid ? parseInt(pid, 10) : null));
      });

      var single = form.querySelector('[data-single-price]');
      if (single) {
        single.innerHTML = (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') + formatMoney(v.price);
      }

      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.innerHTML = 'Add to bag &middot; <span data-button-price>' + formatMoney(priceFor(v, planId)) + '</span>';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        }
      }
    }

    // Variant options
    var optionInputs = form.querySelectorAll('[data-option-input]');
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        product.options.forEach(function (_, i) {
          var checked = form.querySelector('input[name="option' + (i + 1) + '"]:checked');
          selected.push(checked ? checked.value : null);
        });
        var match = product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
        if (match) {
          idInput.value = match.id;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
        refresh();
      });
    });

    form.querySelectorAll('[data-plan-radio]').forEach(function (r) {
      r.addEventListener('change', refresh);
    });

    // Quantity
    var qty = form.querySelector('[data-quantity] input');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    refresh();
  });

  /* ---------- Tabs ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-tab]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          var selected = b === btn;
          b.setAttribute('aria-selected', selected);
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      });
    });
  });
})();
